<template>
    <v-flex>
        <v-flex v-for="customField of customFields" :key="customField.id">                        
            <v-select
                v-if="customField.type.internalName == 'select'"
                :items="customField.allowedValues"
                item-value="value"
                item-text="value"
                :label="customField.name"
                v-model="selectedCustomFields[customField.name]"
                @change="emitObject"
            ></v-select>
            <v-checkbox 
                v-if="customField.type.internalName == 'checkbox'"
                v-model="selectedCustomFields[customField.name]" 
                :value="customField.allowedValues[1].value"
                :label="customField.name"
                @change="emitObject"            
            ></v-checkbox>
            <v-slider
                :label="customField.name"
                v-if="customField.type.internalName == 'numeric_range'"
                v-model="selectedCustomFields[customField.name]"                             
                :max="rangeMaximum(customField.allowedValues)"
                :min="rangeMinimum(customField.allowedValues)"
                thumb-label="always"     
                @change="emitObject"                                   
            ></v-slider>
            <v-text-field
                v-if="customField.type.internalName == 'numeric'"
                v-model="selectedCustomFields[customField.name]" 
                mask="############"
                :label="customField.name"
                @change="emitObject"            
            ></v-text-field>
            <v-text-field
                v-if="customField.type.internalName == 'time'"
                v-model="selectedCustomFields[customField.name]"                             
                :label="customField.name"
                prepend-icon="far fa-clock"
                mask="time"
                @change="emitObject"            
            ></v-text-field>
            <template v-if="customField.type.internalName == 'date'">
                <v-menu
                    v-model="showElementModel[customField.name]"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                    <v-text-field
                        slot="activator"
                        v-model="selectedCustomFields[customField.name]"
                        :label="customField.name"
                        prepend-icon="event"
                        readonly          
                        @change="emitObject"          
                    >
                    </v-text-field>
                    <v-date-picker 
                        v-model="selectedCustomFields[customField.name]" 
                        @input="showElementModel[customField.name] = false">
                    </v-date-picker>                                                
                </v-menu>
            </template>                                                                                
            <v-text-field
                v-if="customField.type.internalName == 'text'"
                v-model="selectedCustomFields[customField.name]"        
                @change="emitObject"                     
                :label="customField.name"
            ></v-text-field>                                        
        </v-flex>
    </v-flex>
</template>
<script>
    import _ from 'lodash';

    export default {
        data() {
            return {
                selectedCustomFields:[]
            }
        },
        props: {
            value:{},
            customFields: {
                type: Array                
            },
        },
        methods: {
            rangeMaximum(values){
                let maxKey = _.max(Object.keys(values), v => values[v]);            
                return values[maxKey].value
            },
            rangeMinimum(values){
                let minKey = _.min(Object.keys(values), v => values[v]);
                
                return values[minKey].value
            },
            emitObject(){
                this.$emit('input', this.selectedCustomFields)
            }
        },
        watch: {
            'value': {
                handler:function(newValue){                    
                    this.selectedCustomFields = newValue;                    
                },
                deep:true
            }
        },        
        mounted(){
            this.selectedCustomFields = this.value
        }
    }
</script>

<style lang="scss" scoped>

</style>